// Header displays the header image and the page's title
//    - @author Manuel Ondina <manuel-rafael.ondina-aja@hp.com>
//    - @date June 9th, 2023
//    - @copyright Copyright (c) HP Inc, 2023
//        All rights reserved. Copying or other reproduction of this program except
//        for archival purposes is prohibited without written consent of HP Inc.

import React from 'react';
import {
  ContentContainer,
  LogoContainer,
  TextContainer,
  marginText,
  textStyle,
  textTitleStyle
} from './styles';
import { LogoHp } from '@veneer/core';
import { Button } from '@veneer/core';
import useShellRootContext from '../../contexts/ShellRoot/useShellRootContext';
// Content displays the header image and the page's title
const Content = () => {
  const { t } = useShellRootContext();
  return (
    <ContentContainer id="content-wrapper">
      <LogoContainer>
        <LogoHp size={80} />
      </LogoContainer>
      <TextContainer>
        <h3
          id="title"
          style={textTitleStyle}
          className="title-regular"
        >
          {t('Smart Digitization is now part of HP Build Workspace')}
        </h3>
      </TextContainer>
      <TextContainer style={marginText}>
        <p
          id="subtitle"
          style={textStyle}
          className="body-large"
        >
          {t('We will redirect you shortly...')}
          <br />
          {t('If you do not want to wait, please click here.')}
        </p>
      </TextContainer>
      <Button
        id="button"
        onClick={() => {
          window.location.href = 'https://build.hp.com';
        }}
      >
        {t('HP Build Workspace')}
      </Button>
    </ContentContainer>
  );
};

export default Content;
